import {createContext} from "react";

const SchoolScreen = createContext<any>(null);

export default SchoolScreen;
